import { baseApi } from './baseApi'
import { IncomingDocumentsEntry } from 'store/types'

export const incomingDocumentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIncomingDocuments: builder.query<IncomingDocumentsEntry[], void>({
      query: () => ({ url: `/lab/incoming-documents` }),
      providesTags: ['IncomingDocument'],
    }),
    deleteIncomingDocument: builder.mutation<void, { uuid: string }>({
      query: ({ uuid }) => ({
        method: `DELETE`,
        url: `/lab/incoming-documents/${uuid}`,
      }),
      invalidatesTags: () => ['IncomingDocument', 'OrderCounts'],
    }),
  }),
})

export const {
  useGetIncomingDocumentsQuery,
  useDeleteIncomingDocumentMutation,
} = incomingDocumentsApi
